module.exports = __webpack_public_path__ + "static/img/container.35bc4b09.png";